import React from 'react';
import { Linkedin, Github, Mail, Globe, Command } from 'lucide-react';
import { BugReportModal } from '@/components/common/BugReportModal';

export function Footer() {
  return (
    <footer className="sticky bottom-0 shrink-0 min-h-[40px] pb-2 sm:pb-1 border-t border-slate-300 dark:border-slate-800 bg-white dark:bg-slate-950 px-2 sm:px-4 text-[10px] sm:text-xs font-medium text-slate-500 dark:text-slate-400 z-50">
      {/* Mobile Layout */}
      <div className="flex flex-col w-full h-full sm:hidden pt-1 pb-2 sm:py-1 justify-center gap-1">
        <div className="grid grid-cols-[1fr_auto_1fr] items-center w-full">
          <div className="flex items-center justify-start opacity-80 hover:opacity-100 transition-opacity truncate pr-1 pl-3 sm:pl-0">
            Built by Farhad Rezaei
          </div>
          
          <div className="flex items-center gap-3 justify-center">
            <a href="https://www.linkedin.com/in/rezaei-farhad/" target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-slate-900 dark:hover:text-slate-200 transition-colors">
              <Linkedin className="w-3.5 h-3.5" />
            </a>
            <a href="https://github.com/rzfarhad73" target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-slate-900 dark:hover:text-slate-200 transition-colors">
              <Github className="w-3.5 h-3.5" />
            </a>
            <a href="https://www.farhad-rezaei.com/" target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-slate-900 dark:hover:text-slate-200 transition-colors">
              <Globe className="w-3.5 h-3.5" />
            </a>
          </div>

          <div className="flex items-center justify-end pr-3 sm:pr-0">
            <BugReportModal />
          </div>
        </div>
        <div className="text-[8px] opacity-60 text-center px-4 leading-tight">
          This site is protected by reCAPTCHA and the Google{' '}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="hover:underline">Privacy Policy</a> and{' '}
          <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" className="hover:underline">Terms of Service</a> apply.
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden sm:grid grid-cols-[1fr_auto_1fr] items-center w-full h-full min-h-[36px] py-1">
        <div className="flex flex-col justify-center">
          <span className="opacity-80 hover:opacity-100 transition-opacity relative top-0.5">Built by Farhad Rezaei</span>
          <span className="text-[9px] opacity-60 relative -bottom-0.5">
            Protected by reCAPTCHA and the Google{' '}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="hover:underline">Privacy Policy</a> and{' '}
            <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" className="hover:underline">Terms of Service</a> apply.
          </span>
        </div>

        <div className="flex items-center gap-x-4 justify-center">
          <a href="https://www.linkedin.com/in/rezaei-farhad/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 hover:text-slate-900 dark:hover:text-slate-200 transition-colors">
            <Linkedin className="w-3.5 h-3.5" />
            <span>LinkedIn</span>
          </a>
          <a href="https://github.com/rzfarhad73" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 hover:text-slate-900 dark:hover:text-slate-200 transition-colors">
            <Github className="w-3.5 h-3.5" />
            <span>GitHub</span>
          </a>
          <a href="https://www.farhad-rezaei.com/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 hover:text-slate-900 dark:hover:text-slate-200 transition-colors">
            <Globe className="w-3.5 h-3.5" />
            <span>Website</span>
          </a>
        </div>

        <div className="flex items-center justify-end">
          <BugReportModal />
        </div>
      </div>
    </footer>
  );
}
